import React, { useState, useEffect, useRef } from 'react';

/**
 * CountryPath Component
 * Renders a single country path with beacon support
 */
const CountryPath = ({ pathData, commonProps, hasBeacon, type }) => {
  const pathRef = useRef(null);
  const [beaconPos, setBeaconPos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (pathRef.current && hasBeacon) {
      try {
        const bbox = pathRef.current.getBBox();
        setBeaconPos({
          x: bbox.x + bbox.width / 2,
          y: bbox.y + bbox.height / 2
        });
      } catch (e) {
        // Fallback if getBBox fails
        setBeaconPos({ x: 0, y: 0 });
      }
    }
  }, [hasBeacon, pathData.d, pathData.points]);

  const renderBeacon = () => {
    if (!hasBeacon) return null;
    
    return (
      <circle
        cx={beaconPos.x}
        cy={beaconPos.y}
        r="6"
        fill="white"
        style={{
          filter: 'drop-shadow(0 0 8px white)',
          animation: 'beaconBlink 1.5s ease-in-out infinite',
          pointerEvents: 'none'
        }}
      />
    );
  };

  if (type === 'path') {
    return (
      <g>
        <path
          {...commonProps}
          d={pathData.d}
          ref={pathRef}
        />
        {renderBeacon()}
      </g>
    );
  } else if (type === 'polygon') {
    return (
      <g>
        <polygon
          {...commonProps}
          points={pathData.points}
          ref={pathRef}
        />
        {renderBeacon()}
      </g>
    );
  } else if (type === 'circle') {
    // Ensure r, cx, cy are valid numbers
    const radius = pathData.r && !isNaN(Number(pathData.r)) ? Number(pathData.r) : null;
    const centerX = pathData.cx && !isNaN(Number(pathData.cx)) ? Number(pathData.cx) : null;
    const centerY = pathData.cy && !isNaN(Number(pathData.cy)) ? Number(pathData.cy) : null;
    
    // Don't render if circle data is invalid (would create orbs at origin)
    if (!radius || centerX === null || centerY === null) {
      return null;
    }
    
    return (
      <g>
        <circle
          {...commonProps}
          cx={centerX}
          cy={centerY}
          r={radius}
        />
        {hasBeacon && (
          <circle
            cx={centerX}
            cy={centerY}
            r="6"
            fill="white"
            style={{
              filter: 'drop-shadow(0 0 8px white)',
              animation: 'beaconBlink 1.5s ease-in-out infinite',
              pointerEvents: 'none'
            }}
          />
        )}
      </g>
    );
  }
  
  return null;
};

export default CountryPath;

